export default {
  edit: 'editar',
  archive: 'ocultar',
  delete: 'apagar',
  editors: 'editores',
  status: 'estado',
  page: 'página',
  config: 'configurações',
  loading: 'a carregar dados',
  name: 'nome',
  category: 'categoria',
  phoneExtension: 'extensão telefónica',
  email: 'e-mail',
  'section.quick.subweb': 'acesso rápido (subwebs)',
  'section.quick.page': 'acesso rápido (páginas)',
  'section.table.subweb': 'todas as subwebs',
  'section.table.page': 'todas as páginas',
  'subweb.people': 'pessoas',
  'subweb.edit': 'páginas',
  'subweb.new': 'criar subweb',
  'subweb.permissions': 'permissões',
  'subweb.edit.menu': 'menu',
  'subweb.settings': 'definições',
  'resources.view': 'recursos',
  'error.missing': 'sem informação',
  'page.state.prePublished': 'pré-visualização criada',
  'page.state.published': 'publicado',
  'page.state.local': 'edições por gravar',
  'page.state.edited': 'edições gravadas',
  'page.state.archive': 'ocultado',
  'page.state.draft': 'rascunho',
  'page.state.none': 'indisponível',
  'page.state.error': 'erro a obter estado',
  'page.new': 'criar página',
  'page.delete': 'apagar página',
  'page.search': 'pesquisar páginas',
  'page.slug': 'endereço amigável',
  'subwebs.delete': 'apagar subweb',
  'subwebs.search': 'pesquisar subwebs',
  'subwebs.title': 'título',
  'subwebs.slug': 'endereço amigável',
  'subwebs.visit': 'visitar',
  'home.title': 'Editor',
  'table.title.last': 'última edição',
  'lang.pt.feminim': 'portuguesa',
  'lang.en.feminim': 'inglesa',
  file: 'ficheiro',
  'file.title': 'nome',
  'file.type': 'tipo',
  'file.size': 'tamanho',
  'file.date': 'modificado em',
  'file.copy': 'copiar link',
  'file.download': 'descarregar',
  'file.edit': 'editar',
  'file.delete': 'apagar',
  'file.numberDownloads': 'número de downloads',
  'file.lastdownload': 'último download',
  // this messages were missing in order to be able to test formattedMessages
  // that would eventually be rendered by the lib component
  'app.content.empty': 'Nenhum conteúdo para exibir',
  'app.course.curricular': 'Plano Curricular',
  'app.course.edicts': 'Editais de abertura',
  'app.course.edicts.icon.documents': 'Aceder aos documentos',
  'app.departments.list.description': 'A Universidade de Aveiro é constituida por 16 departamentos, que se interrelacionam consoante a interdisciplinaridade dos cursos que integram ou das áreas de investigação que partilham.',
  'app.departments.list.subTitle': 'Departamentos',
  'app.departments.list.title': 'Departamentos e Escolas',
  'app.departments.polytechnics.title': 'Escolas Politécnicas',
  'app.events.action.back': 'voltar',
  'app.events.action.today': 'hoje',
  'app.events.empty': 'Sem Resultados de eventos',
  'app.events.select.categories': 'categorias',
  'app.events.select.channel': 'canal',
  'app.footer.accessibility': 'Acessibilidade',
  'app.footer.contacts': 'Contactos',
  'app.footer.newPortal': 'Novo Portal',
  'app.footer.prospectiveStudents': 'futuros estudantes',
  'app.footer.uaStudents': 'estudantes ua',
  'app.footer.internationalStudents': 'estudantes internacionais',
  'app.footer.uaPeople': 'pessoas ua',
  'app.footer.society': 'sociedade',
  'app.footer.services': 'serviços',
  'app.footer.researchUnits': 'unidades de investigação',
  'app.footer.publics': 'Públicos',
  'app.footer.follow': 'Segue-nos',
  'app.footer.general.contacts': 'contactos gerais',
  'app.footer.library': 'biblioteca',
  'app.footer.links': 'Links Rápidos',
  'app.footer.map': 'Mapa do site',
  'app.footer.protection': 'Proteção de dados',
  'app.nav.International': 'internacional',
  'app.nav.International.item.candidature': 'candidatura',
  'app.nav.International.item.infocourse': 'informações úteis',
  'app.nav.International.item.information': 'informação útil',
  'app.nav.International.item.international.cooperation': 'cooperação internacional',
  'app.nav.International.item.internationalCooperation': 'cooperação internacional',
  'app.nav.International.item.internationalStudyAtUA': 'estudar e investigar',
  'app.nav.International.item.internship': 'estágios internacionais',
  'app.nav.International.item.living': 'preparar a vinda',
  'app.nav.International.item.livingAveiro': 'viver em Aveiro',
  'app.nav.International.item.livingAveiro.campusesLife': 'vida nos campi',
  'app.nav.International.item.livingAveiro.internationalBefore': 'preparar a vinda',
  'app.nav.International.item.livingAveiro.internationalSupport': 'serviços de apoio',
  'app.nav.International.item.mobility': 'mobilidade',
  'app.nav.International.item.mobility.mobilityIncoming': 'mobilidade incoming',
  'app.nav.International.item.mobility.mobilityOutgoing': 'mobilidade outgoing',
  'app.nav.International.item.students': 'estudar em portugal',
  'app.nav.International.item.study': 'estudar e investigar',
  'app.nav.International.item.whyPortugal': 'porquê Portugal?',
  'app.nav.International.item.whyPortugal.internationalApplication': 'candidaturas',
  'app.nav.International.item.whyPortugal.internationalFees': 'taxas e anuidades',
  'app.nav.International.item.whyPortugal.internationalScholarships': 'bolsas e financiamento',
  'app.nav.International.item.whyPortugal.researchFacilities': 'onde investigar?',
  'app.nav.International.item.whyPortugal.whatToStudy': 'o que estudar?',
  'app.nav.about': 'sobre a ua',
  'app.nav.about.item.aboutUs': 'sobre nós',
  'app.nav.about.item.campus': 'os campi',
  'app.nav.about.item.community': 'comunidade',
  'app.nav.about.item.events': 'novidades e eventos',
  'app.nav.about.item.history': 'história',
  'app.nav.about.item.history.formerRectors': 'antigos reitores',
  'app.nav.about.item.history.honorisCausa': 'honoris causa',
  'app.nav.about.item.numbers': 'factos e números',
  'app.nav.about.item.organization': 'organização',
  'app.nav.about.item.presentation': 'universidade',
  'app.nav.about.item.quality': 'qualidade',
  'app.nav.aboutUs': 'sobre nós',
  'app.nav.acknowledgment': 'colaborações',
  'app.nav.education': 'estudar',
  'app.numbers.study': 'Estudar',
  'app.nav.education.item.aftercourse': 'estágios e emprego',
  'app.nav.education.item.aplication': 'candidaturas',
  'app.nav.education.item.aplication.MTwentyThree': 'maiores de 23',
  'app.nav.education.item.aplication.cna': ' concurso nacional de acesso',
  'app.nav.education.item.aplication.internationalStudents': 'estudantes internacionais',
  'app.organism.news.warnings': 'Avisos',
  'app.nav.education.item.aplication.isolatedSubjects': 'unidades curriculares isoladas',
  'app.nav.education.item.aplication.localApplication': 'concurso local para licenciatura em música',
  'app.nav.education.item.aplication.postGradApplications': 'candidatura a pós-graduação',
  'app.nav.education.item.covid': 'coronavírus',
  'app.nav.education.item.aplication.specialAdmissions': 'concursos especiais',
  'app.nav.education.item.aplication.tespInfo': 'técnicos superiores profissionais',
  'app.nav.education.item.candidature': 'candidaturas',
  'app.nav.education.item.courses': 'cursos',
  'app.nav.education.item.courses.c.1': 'licenciaturas e mestrados integrados',
  'app.nav.education.item.courses.g.10': 'técnicos superiores profissionais',
  'app.nav.education.item.courses.g.4': 'mestrados',
  'app.nav.education.item.courses.g.9': 'programas doutorais',
  'app.nav.education.item.courses.moreLearning': 'outras formas de estudar',
  'app.nav.education.item.courses.otherPostGrad': 'outras pós-graduações',
  'app.nav.education.item.departments': 'departamentos e escolas',
  'app.nav.education.item.edicts': 'editais',
  'app.nav.education.item.live': 'viver na ua',
  'app.nav.education.item.registration': 'matrículas',
  'app.nav.education.item.registration.cna': 'concurso nacional de acesso',
  'app.nav.education.item.registration.posgrad': 'cursos de pós-graduação',
  'app.nav.education.item.registration.special': 'concursos especiais',
  'app.nav.education.item.registration.tesp': 'técnicos superiores profissionais',
  'app.nav.education.item.registration.faq': 'perguntas frequentes',
  'app.nav.education.item.registration.welcome': 'acolhimento',
  'app.nav.education.item.study': 'estudar na UA',
  'app.nav.education.item.teachingSupport': 'apoio ao ensino',
  'app.nav.education.item.studySupport': 'apoio ao estudo',
  'app.nav.education.item.studySupport.academicSupport': 'apoio à aprendizagem',
  'app.nav.education.item.studySupport.libraries': 'bibliotecas e salas de estudo',
  'app.nav.education.item.studySupport.scholarshipsAwards': 'bolsas e prémios',
  'app.nav.guide': 'sobre o portal',
  'app.nav.feedback': 'enviar feedback',
  'app.nav.innovation': 'cooperar',
  'app.nav.innovation.item.cooperate': 'balcão de cooperação',
  'app.nav.innovation.item.cooperatesupport': 'balcão de cooperação',
  'app.nav.innovation.item.development': 'áreas de cooperação',
  'app.nav.innovation.item.entrepreneurship': 'empreendedorismo',
  'app.nav.innovation.item.pci': 'impacto na região',
  'app.nav.innovation.item.portfolio': 'portefólio',
  'app.nav.about.item.campus.howArrive': 'como chegar',
  'app.nav.innovation.item.programs': 'empreendedorismo',
  'app.nav.innovation.item.ua.cooperate': 'cooperação com a UA',
  'app.nav.innovation.item.ua.innovation': 'cooperação com a UA',
  'app.nav.investigation': 'investigar',
  'app.nav.investigation.item.research.units': 'unidades de investigação',
  'app.nav.investigation.item.activity': 'atividade científica',
  'app.nav.investigation.item.activity.chairs': 'cátedras',
  'app.nav.investigation.item.activity.fundingReports': 'revista da investigação',
  'app.nav.investigation.item.activity.idProjects': 'projetos I&D',
  'app.nav.investigation.item.activity.openScience': 'ciência aberta',
  'app.nav.investigation.item.activity.researchUnits': 'unidades de investigação',
  'app.nav.investigation.item.activity.scientificResearch': 'produção cientifíca',
  'app.nav.investigation.item.research': 'investigar na UA',
  'app.nav.investigation.item.school': 'escola doutoral',
  'app.nav.investigation.item.support': 'apoios e financiamento',
  'app.nav.investigation.item.support.fundingOne': 'financiamento',
  'app.nav.investigation.item.support.hiring': 'bolsas e recrutamento',
  'app.nav.investigation.item.support.mobilityFund': 'fundo de mobilidade',
  'app.nav.investigation.item.supportreseacrh': 'apoio à investigação',
  'app.nav.investigation.item.supportresearch': 'apoio à investigação',
  'app.nav.live': 'viver',
  'app.nav.live.item.culture': 'cultura e tempos livres',
  'app.nav.live.item.eating': 'alimentação',
  'app.nav.live.item.health': 'saúde e bem-estar',
  'app.nav.live.item.live': 'vida académica',
  'app.nav.live.item.sleeping': 'alojamento',
  'app.nav.live.item.sports': 'desporto',
  'app.nav.live.item.study': 'viver na UA',
  'app.nav.live.item.study.publicServices': 'serviços públicos',
  'app.nav.live.item.study.transportation': 'transportes',
  'app.nav.live.item.study.distanceTraining': 'exercício em casa',
  'app.nav.live.item.study.healthHome': 'fica bem em casa',
  'app.nav.live.item.study.uaCities': 'cidades UA',
  'app.nav.public.alumni': 'Alumni',
  'app.nav.public.social.news': 'Notícias',
  'app.nav.public.social.agenda': 'Agenda',
  'app.nav.public.society': 'Sociedade',
  'app.nav.public.students.future': 'Futuros Estudantes',
  'app.nav.public.students.international': 'Estudantes Internacionais',
  'app.nav.public.students.ua': 'Estudantes UA',
  'app.nav.public.ua.people': 'Pessoas UA',
  'app.nav.public.who': 'Quem sou?',
  'app.numbers.campi': 'Campi',
  'app.numbers.community': 'Comunidade',
  'app.numbers.cooperation': 'Cooperar',
  'app.numbers.employability': 'Empregabilidade',
  'app.numbers.employability.data': 'Dados de empregabilidade',
  'app.numbers.international': 'Internacional',
  'app.numbers.investigation': 'Investigar',
  'app.numbers.live': 'Viver',
  'app.organism.agenda.title': 'Agenda',
  'app.organism.campus.title': 'Destaques',
  'app.organism.facts.title': '19 dos 20 centros de investigação científica da UA avaliados pela FCT receberam classificação de excelente e muito bom',
  'app.organism.facts.university.title': 'Entre as 100 melhores instituições de ensino superior da Europa',
  'app.organism.news.title': 'Notícias',
  'app.organism.testimonials.title': 'Os nossos estudantes',
  'app.search.all.title': 'Todo o Portal',
  'app.search.empty': 'Sem conteúdos para a pesquisa',
  'app.search.locals.title': 'Locais',
  'app.search.map': 'Ver no mapa',
  'app.search.news.title': 'Notícias',
  'app.search.people.title': 'Pessoas',
  'app.search.placeholder.a': 'Pesquisa todo o portal',
  'app.search.placeholder.default': 'Pesquisa em páginas, ficheiros, pessoas, notícias e locais',
  'app.search.placeholder.l': 'Pesquisa por departamentos e outros locais',
  'app.search.placeholder.n': 'Pesquisa por notícias e agenda',
  'app.search.placeholder.p': 'Pesquisa por pessoas',
  'app.journal.nav.title': 'Notícias',
  'app.journal.news.investigation.title': 'Investigação',
  'app.journal.news.interviews.title': 'Entrevistas',
  'app.journal.news.campus.title': 'Campus',
  'app.journal.news.opinion.title': 'Opinião',
  'app.journal.news.sport.title': 'Cultura e desporto',
  'app.journal.news.mostRead.title': 'Mais lidas',
  'app.journal.news.latest.title': 'Últimas',
  'app.journal.news.dossier.title': 'COVID-19',
  'app.journal.news.dossier.all.title': 'Ver todos os dossiês',
  'app.journal.news.academicExams.title': 'Provas académicas',
  'app.journal.news.scholarshipsJobs.title': 'Bolsas e emprego',
  'app.journal.news.contestsAwards.title': 'Concursos e prémios',
  'app.journal.news.footer.about': 'Sobre as notícias',
  'app.journal.news.footer.contacts': 'Contactos',
  'app.journal.news.share.feedback': 'Url copiado para clipboard',
  'app.journal.news.share.button.title': 'Copiar para Clipboard',
  'app.journal.errorHandler.message.title': 'Ups! Página não encontrada',
  'app.journal.errorHandler.message.firstPart': 'A página à qual tentou aceder não se encontra disponívelasldjknasofjansfpoja. Esta pode ter sido removida, estar temporariamente indisponível ou o seu endereço estar incorreto. Faça uma ',
  'app.journal.errorHandler.message.secondPart': 'ou volte à',
  'app.journal.errorHandler.homepage.link': 'página inicial',
  'app.journal.errorHandler.search.link': 'pesquisa',
  'app.journal.errorHandler.button.play': 'Jogar',
  'app.journal.errorHandler.button.restart': 'Jogar de novo',
  'app.journal.errorHandler.next.player': 'Próximo jogador: {player}',
  'app.journal.errorHandler.winner': 'Vencedor: {player}',
  'app.journal.errorHandler.tie': 'Empate {player}',
  'app.journal.errorHandler.general.message.title': 'Algo correu mal',
  'app.journal.errorHandler.general.message.firstPart': 'Lamentamos o incómodo mas de momento não é possível mostrar o que procurava. Estamos a trabalhar para resolver o problema. Faça uma ',
  'app.journal.errorHandler.general.message.secondPart': 'ou volte à',
  'app.journal.errorHandler.general.homepage.link': 'página inicial',
  'app.journal.errorHandler.general.search.link': 'pesquisa',
  'app.organism.button.knowMore': 'saber mais',
  'app.organism.button.LoadMore': 'Carregar mais',
  'app.journal.news.details.print': 'Imprimir',
  'app.course.shortInfo.departamentsAndSchools': 'Departamentos/Escolas politécnicas',
  'app.journal.directory.navigate.alphabet': 'Clicar em enter para navegar no alfabeto',
  'app.course.edicts.icon.empty.documents': 'Ausência de documentos',
  'app.socialMediaActions.button.description': 'Botão para abrir menu para partilhar noticia nas redes socias',
  'app.breadcrumbs.button.description': 'Botão para abrir menu com mais breadcrumbs',
  'app.projects.projectsList.title': 'Projetos I&D',
  'app.projects.projectsList.table.title': 'projeto',
  'app.projects.projectsList.description': 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Amet atque cumque, laborum minus nam quam similique. Alias aspernatur corporis cumque distinctio doloribus excepturi, magnam, nesciunt numquam quis saepe tempore totam. Lorem ipsum dolor sit amet, consectetur adipisicing elit. Accusantium, ipsa.',
  'app.projects.projectsList.search.title': 'Pesquisar projetos',
  'app.projects.projectsList.search.placeholder': 'Procurar um projeto, investigador responsável ou financiamento',
  'app.projects.projectsList.filter.startDate': 'data de início',
  'app.projects.projectsList.filter.endDate': 'data de conclusão',
  'app.projects.projectsList.filter.entity': 'entidate financiadora',
  'app.projects.projectsList.search.button': 'Pesquisar',
  'app.lastUpdate.text': 'última atualização a',
  'app.header.video.button.audioDescription': 'Vídeo com audiodescrição',
  'app.header.video.button.play': 'Ver Vídeo'
}
